import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import { icons, images } from "../../assets";
import AuthLayout from "../../components/authLayout";
import CustomButton from "../../components/customButton";
import { useNavigate } from "react-router-dom";
import AppLoader from "../../components/appLoader";
import TextInput from "../../components/textInput";
import { adminForgotPassword } from "../../services/Auth";
import { openSnackAlert } from "../../helper";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const handleChange = (event) => {
    setEmail(event.target.value);
    setError("");
  };

  const validateEmail = () => {
    if (!email.trim()) {
      setError("Email is required.");
      return false;
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      setError("Email is invalid.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateEmail()) return;

    setIsLoading(true);
    const payload = {
      email: email,
    };
    try {
      const response = await adminForgotPassword(payload);
      if (response?.data?.status === "success") {
        openSnackAlert("OTP sent to email", "success");
        navigate("/otp-verification", { state: { email } });
      } else {
        openSnackAlert(response?.data?.message || "Error occurred", "error");
      }
    } catch (error) {
      openSnackAlert("Something went wrong! Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <AuthLayout>
      <AppLoader isVisible={isLoading} />
      <Box
        p={6}
        py={4}
        mt={3}
        width={{ xs: 400, sm: 520 }}
        bgcolor="#fff"
        borderRadius="16px"
        boxShadow="0 4px 30px rgba(0, 0, 0, 0.1)"
      >
        <Box
          sx={{
            textDecoration: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <img
            src={icons.applogo}
            alt="Capacity&Care"
            style={{ height: "60px" }}
          />
        </Box>
        <Typography textAlign={"center"} my={3} fontSize={14} fontWeight={600}>
          FORGOT PASSWORD
        </Typography>

        <Typography variant="label" mb={2}>
          Enter your email address
        </Typography>
        <TextInput
          name="email"
          value={email}
          onChange={handleChange}
          placeholder="example@gmail.com"
          sx={{
            borderRadius: "22px",
            my: 1,
            mb: 2,
          }}
          helperText={error}
          error={error}
        />

        <CustomButton
          width={"100%"}
          btnLabel={"Send Reset Link"}
          variant="authbutton"
          borderRadius="28px"
          btnTextColor={"#ffff"}
          height={"50px"}
          handlePressBtn={handleSubmit}
        />
      </Box>
    </AuthLayout>
  );
};

export default ForgotPassword;
